export default class GroupVideoManager {

    constructor() {
        this.eventDelegation();
    }

    eventDelegation() {
        let videos = document.querySelectorAll(".video-chollo-card");
        let videosPlayed = [];

        videos.forEach((video) => {
            let observer = new IntersectionObserver((entries) => {
                const videoId = video.getAttribute('data-id');
                if (entries[0].isIntersecting && video.paused && !videosPlayed.find(videosPlayed => videosPlayed.id == videoId)) {
                    const playPromise = video.play();
                    let videoObject = {
                        id: videoId,
                        isPlayed: playPromise
                    };

                    playPromise.then(() => {
                        if (!video.paused) {
                            videosPlayed.push(videoObject);
                        }
                    }).catch(() => {
                        video.play().catch(() => { this._showDefaultPicture(video); });
                    });
                } else if (videosPlayed.find(videosPlayed => videosPlayed.id == videoId)) {
                    if (!video.paused && videosPlayed.find(videosPlayed => videosPlayed.id == videoId).isPlayed) {
                        videosPlayed.find(videosPlayed => videosPlayed.id == videoId).isPlayed.then(() => {
                            video.pause();
                            videosPlayed = videosPlayed.filter(element => element.id !== videoId);
                        });
                    }
                }
            }, {threshold: 0.5});
            observer.observe(video);
        });
    }

    _showDefaultPicture(video) {
        const picture = video.parentElement.querySelector('picture');
        if (!picture) {
            return;
        }

        picture.style.display = '';
        video.style.display = 'none';
    }
}
